import { render, staticRenderFns } from "./RegisterConfirm.vue?vue&type=template&id=49f16292&scoped=true"
import script from "./RegisterConfirm.vue?vue&type=script&lang=ts"
export * from "./RegisterConfirm.vue?vue&type=script&lang=ts"
import style0 from "./RegisterConfirm.vue?vue&type=style&index=0&id=49f16292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f16292",
  null
  
)

export default component.exports